import { render, staticRenderFns } from "./StockAddNew.vue?vue&type=template&id=75dbf322&scoped=true&"
import script from "./StockAddNew.vue?vue&type=script&lang=js&"
export * from "./StockAddNew.vue?vue&type=script&lang=js&"
import style0 from "./StockAddNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StockAddNew.vue?vue&type=style&index=1&id=75dbf322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dbf322",
  null
  
)

export default component.exports